import * as css from 'css/exports.module.scss';
import './RecordTags.scss';
import classNames from 'classnames';
import React from 'react';
import { Space } from 'antd';
import { When } from 'react-if';
import { SonarTagDisplay, SonarTagManager } from '../tags';
import { useCurrentUser, useSonarObjectReference } from '@hooks';
export const SonarRecordTags = ({ alignLeft, sonarObjectId, hideTagManager }) => {
    var _a, _b;
    const tagIds = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.tagIds) !== null && _b !== void 0 ? _b : [];
    const { isReadOnly } = useCurrentUser();
    const allowTagEdit = !isReadOnly && !hideTagManager;
    const className = classNames('sonar-record-tags', { 'align-left': alignLeft });
    return (React.createElement(Space, { className: className, size: Number(css.size4), wrap: true },
        tagIds.map((id) => React.createElement(SonarTagDisplay, { key: id, tagId: id })),
        React.createElement(When, { condition: allowTagEdit },
            React.createElement(SonarTagManager, { sonarObjectId: sonarObjectId }))));
};
